import { ABMMenuType, GetABMMENUDispatchTypes, GET_ABMMENU_FAIL, GET_ABMMENU_LOADING, GET_ABMMENU_SUCCESS } from './ABMMenuActionTypes';


export interface ABMMenuDefaultStateI {
    loading : boolean,
    abmmenu? : any
}


const defaultState : ABMMenuDefaultStateI = {
    loading : false
};


const ABMMenuReducer = (state: ABMMenuDefaultStateI = defaultState, action:GetABMMENUDispatchTypes): ABMMenuDefaultStateI =>{
    switch (action.type) {
        case GET_ABMMENU_FAIL:
            return {
                loading:false
            }
            break;
        case GET_ABMMENU_LOADING:
            return {
                loading:true
            }
            break;
        case GET_ABMMENU_SUCCESS:
            return {
                loading:false,
                abmmenu:action.payload
            }
            break;   
        default:
            return state
            break;
    }
    return state;
}


export default ABMMenuReducer;